import { Box, Button, Paper, Typography, useTheme } from '@mui/material';

interface Props {
  onComplete: () => void;
  onBack: () => void;
}

export default function Step5Complete({ onComplete, onBack }: Props) {
  const theme = useTheme();

  return (
    <Box sx={{ mt: 2, textAlign: 'center' }}>
      <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', mb: 2 }}>
        You're all set!
      </Typography>

      <Typography variant="body1" sx={{ mb: 4, fontSize: '1.2rem', maxWidth: 800, mx: 'auto' }}>
        The Dashboard gives you an overview of your active tenders. When you add a tender, it will
        appear in the "Go / No Go" tab or "Active Tenders" depending on its status.
      </Typography>

      <Paper
        sx={{
          p: 4,
          textAlign: 'center',
          backgroundColor: 'background.default',
          mb: 4,
          maxWidth: 800,
          mx: 'auto',
        }}
      >
        <Typography variant="body2" color="text.secondary" sx={{ fontSize: '1.2rem' }}>
          You've completed the basic setup. Now you can explore the capability analysis in your
          tender toolkit. Once you've reviewed the risks and capabilities, click{' '}
          <strong>"PURSUE"</strong> to activate drafting features and begin your submission!
        </Typography>
      </Paper>

      <Box sx={{ mt: 6, display: 'flex', justifyContent: 'center', gap: 2, alignItems: 'center' }}>
        <Button onClick={onBack} variant="outlined" size="large" sx={{ fontWeight: 'bold', px: 4 }}>
          Back
        </Button>
        <Button
          variant="contained"
          size="large"
          sx={{
            fontWeight: 'bold',
            px: 6,
            py: 1.5,
            fontSize: '1.1rem',
            backgroundColor: theme.palette.bidlogiq?.brick || 'primary.main',
            color: 'white',
            '&:hover': {
              backgroundColor: theme.palette.bidlogiq?.rust || 'primary.dark',
            },
          }}
          onClick={onComplete}
        >
          Go to Dashboard
        </Button>
      </Box>
    </Box>
  );
}
